import type { ReactNode } from 'react';

export const symbol_earbud_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M491-491H386v-60h135q12.75 0 21.38 8.62Q551-533.75 551-521v381h106v-381q0-12.75 8.63-21.38Q674.25-551 687-551h93v-189H386v-60h394q24 0 42 18t18 42v189q0 24-18 42t-42 18h-63v351q0 24-18 42t-42 18H551q-24 0-42-18t-18-42v-351ZM188.83-811.5Q257.67-880 356-880q12.75 0 21.38 8.62Q386-862.75 386-850v411q0 12.75-8.62 21.37Q368.75-409 356-409q-98.33 0-167.17-68.76-68.83-68.77-68.83-167 0-98.24 68.83-166.74Zm32.67 277Q263-487 326-471v-347q-63 16-104.5 63T180-645q0 63 41.5 110.5ZM604-645Zm-278 0Z"
		/>
	</svg>
);
